// Copyright (c) 2016 Deere & Company

import React, {PropTypes} from 'react';
import {FormattedMessage} from 'react-intl';
import InputField from './form-fields/input-field';
import PipCode from '@deere/cps-it.warranty-model-factory/lib/pip-code';
import WarrantyDatePicker from '../../../shared/components/warranty-date-picker';
import {buildMoment} from '../../../shared/services/build-moment';

function handleDateChange(date) {

    if (date) {

        this.onItemChange('refusedDate', date.utc().startOf('day').valueOf());

    }

}

function handleTextAreaChange(event) {

    this.onItemChange('reasonForRefusal', event.target.value);

}

const CustomerRefusalDetails = props =>
    <div className='customer-refusal-details'>
        <div className='labeled-string date-picker-wrapper'>
            <span className='data-label asterisk-after'>
                <FormattedMessage id='DATE_REFUSED'/>
            </span>
            <WarrantyDatePicker
                onChange={props::handleDateChange}
                selected={buildMoment(props.pipCode.refusedDate)}
            />
        </div>
        <InputField
            label='WORK_ORDER_NUMBER'
            onItemChange={props.onItemChange}
            propertyToUpdate='workOrderNumber'
        />
        <div className='labeled-string'>
            <span className='data-label asterisk-after'>
                <FormattedMessage id='REASON_FOR_REFUSAL'/>
            </span>
            <textarea
                className='reason-for-refusal'
                maxLength='240'
                onChange={props::handleTextAreaChange}
            />
        </div>
        <InputField
            label='WITNESS_FIRST_NAME'
            onItemChange={props.onItemChange}
            propertyToUpdate='firstName'
        />
        <InputField
            label='WITNESS_LAST_NAME'
            onItemChange={props.onItemChange}
            propertyToUpdate='lastName'
        />
    </div>;

CustomerRefusalDetails.displayName = 'CustomerRefusalDetails';
CustomerRefusalDetails.propTypes = {
    onItemChange: PropTypes.func.isRequired,
    pipCode: PropTypes.instanceOf(PipCode).isRequired
};

export default CustomerRefusalDetails;



// WEBPACK FOOTER //
// ./src/pip/pip-code/components/customer-refusal-details.js